import * as React from "react";

import { singletonHook } from "react-singleton-hook";
import { FaMoon, FaSun } from "react-icons/fa";

const darkModeFactory = () => {
    let darkMode = JSON.parse(localStorage.getItem("dark-mode") || "false");
    const [isDarkMode, setDarkMode] = React.useState(darkMode);

    const toggleDarkMode = () => {
        setDarkMode(!isDarkMode);
        localStorage.setItem("dark-mode", JSON.stringify(!isDarkMode));
    };

    return [isDarkMode, toggleDarkMode];
};

export const useDarkMode = singletonHook([false], darkModeFactory);

let DarkModeSwitch = () => {
    const [isDarkMode, toggleDarkMode] = useDarkMode();

    return (
        <div style={{ padding: "1rem", position: "absolute", right: "1rem", zIndex: 100 }}>
            {isDarkMode && <FaSun onClick={toggleDarkMode} color="#f5d01b" size={18} />}
            {!isDarkMode && <FaMoon onClick={toggleDarkMode} color="#3f51b5" size={16} />}
            {/* <Switch sm defaultChecked={isDarkMode} onClick={toggleDarkMode} /> */}
        </div>
    );
};

export default DarkModeSwitch;
